<template>
    <div class="footer" v-if="!isLogin">
       <div class="left">
           <img src="https://files.wondercv.com/campaign-jobs/pc-running.png" alt="" class="running-img">
           <span>登录超级简历</span>
           <span>名企精英都在用的简历制作神器</span>
       </div>
       <div class="right">
           <a href="javascript:;" class="operate" @click="toReg">
               注册
           </a>
           <a href="javascript:;" class="operate" @click="toLogin">
               登录
           </a>
       </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {routerTo} from '~/assets/js/util'
import { toLogin } from '@/assets/js/jwt'
export default {
  name:'springFooter',
  computed:{
       ...mapState('me', ['isLogin'])
  },
  data(){
   return {
       
   }
  },
  methods:{
     toLogin() {
        toLogin({login:true})
        // routerTo('/auth-signin/?type=login')
     },
     toReg() {
         toLogin({login:true})
        // routerTo('/auth-signin/?type=login')
     },
  }
}
</script>

<style scoped lang='scss'>
.footer{
    position: fixed;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    bottom: 0;
    height: 70px;
    line-height: 70px;
    min-width: 1000px;
    width: 100%;
    padding: 0 178px 0 146px;
    z-index: 99;
    left: 50%;
    transform: translateX(-50%);
    background-color:  rgba(0, 0, 0, 0.7);
    color: #FFFFFF;
    .right{
        display: flex;
        align-items: center;
        width: 246px;
        .operate{
            display: inline-block;
            width: 114px;
            height: 43px; 
            border-radius: 24px;
            line-height: 43px;
            text-align: center;    
            font-size: 20px;
            letter-spacing: 1px;
            font-weight: 500;
            color:#fff;
        }
        &>a:nth-child(1){
            background: #FF6644;
            margin-right: 14px;
        }
        &>a:nth-child(2){
            border: 1px solid #FFFFFF;
        }
    }
    .left{
        display: flex;
        align-items: center;
        &>span:nth-child(2){
            margin-left: 46px;
            margin-right: 23px;        
            font-size: 22px;     
            font-weight: 600;
            height: 70px;  
            min-width: 140px; 
            display: inline-block;
        }
        &>span:nth-child(3){
            font-size: 16px;
            font-weight: 400;
            margin-right: 164px;
            height: 70px;
            min-width: 224px; 
            display: inline-block;
        }
    }
   
}

.running-img{
    width: 118px;
    height: 86px;
    position: relative;
    top: -6px;
    display: inline-block;
    vertical-align: middle;
}
</style>
